<template>
  <div class="goods-list-container" v-loading="pageLoading">
    <el-image
      style="width: 100%"
      v-if="pageFrom == 'special' && specialPic != ''"
      :src="specialPic"
      fit="cover"
    >
    </el-image>
    <el-card
      class="box-card search-box-goodslist"
      shadow="never"
      v-if="
        pageFrom != 'special' &&
        pageFrom != 'quickOrder' &&
        pageFrom != 'groupOrder' &&
        pageFrom != 'couponList'
      "
    >
      <div class="classify-box">
        <div class="title">全部结果</div>
        <div class="icon">﹥</div>
        <el-select
          v-model="value"
          placeholder="请选择"
          size="small"
          @change="change"
        >
          <div slot="prefix">主分类：</div>
          <el-option
            v-for="item in options"
            :key="item.categoryId"
            :label="item.name"
            :value="item.categoryId"
          >
          </el-option>
        </el-select>
        <template v-if="secondOptions.length > 0">
          <div class="icon">﹥</div>
          <el-select
            v-model="secondValue"
            placeholder="请选择"
            size="small"
            class="select-second"
            @change="changeSecond"
          >
            <div slot="prefix">二级分类：</div>
            <el-option
              v-for="item in secondOptions"
              :key="item.categoryId"
              :label="item.name"
              :value="item.categoryId"
            >
            </el-option>
          </el-select>
        </template>
      </div>
    </el-card>
    <div
      class="content"
      v-if="JSON.stringify(couponItem) !== '{}' && pageFrom == 'couponList'"
    >
      <div class="coupon-box">
        <div class="coupon-info">
          <div class="left-box">
            <div class="name">
              <span class="time">优惠券名称：</span>{{ couponItem.name }}
            </div>
            <div class="name">
              <span class="time">优惠券金额：</span
              ><span class="money"
                >￥{{ parseFloat(couponItem.amount)
                }}<span class="tips"
                  >（满￥{{ parseFloat(couponItem.minPoint) }}使用）</span
                >
              </span>
            </div>
            <div
              class="name"
              v-if="couponItem.enableStartTime && couponItem.enableStartTime"
            >
              <span class="time">有效期：</span>
              {{ couponItem.enableStartTime.split(" ")[0] }}&nbsp;-&nbsp;{{
                couponItem.enableEndTime.split(" ")[0]
              }}
            </div>
          </div>
          <div class="right-box"></div>
        </div>
      </div>
    </div>
    <div class="content" v-if="pageFrom == 'groupOrder' && minPoint && amount">
      <div class="coupon-box">
        <div class="coupon-info">
          <div class="left-box">
            <div class="name">
              <span class="time">活动信息：</span
              ><span class="money"
                >满￥{{ parseFloat(minPoint)
                }}<span>减￥{{ parseFloat(amount) }}</span>
              </span>
            </div>
          </div>
          <div class="right-box"></div>
        </div>
      </div>
    </div>
    <template v-if="goodsList.length > 0">
      <div class="product-list">
        <product-components
          v-for="(item, index) in goodsList"
          :product="item"
          :key="index"
          @click="handleRouter(item)"
        />
      </div>
      <div class="pagination-box">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          @current-change="handleCurrent"
          :current-page="pageNum"
          :page-size="20"
        >
        </el-pagination>
      </div>
    </template>
    <el-empty v-else description="暂无数据"></el-empty>
  </div>
</template>

<script>
import {
  getProductSort,
  getCategorySkuProducts,
  search,
  getPmsProductBaseBySubjectId,
  recentPurchase,
  groupOrderApi,
  couponListApi,
} from "@/api/goods.js";
import { mapGetters, mapMutations } from "vuex";
import Cookies from "js-cookie";
import productComponents from "@/components/productComponents";
export default {
  components: {
    productComponents,
  },
  data() {
    return {
      options: [
        {
          categoryId: "",
          name: "全部",
        },
      ], //一级分类选项
      value: "",
      secondValue: "",
      secondOptions: [], //二级分类选项
      goodsList: [], //商品列表
      pageNum: 1,
      total: 0,
      pageFrom: "", //路由来源 special专题 search搜索 types分类
      subjectId: "", //专题id
      specialPic: "", //专题顶部图片
      pageLoading: false,
      historySearchKey: "",
      isCookies: false,
      couponId: "", // 优惠券id
      couponItem: {}, // 优惠券信息
      groupOrderId: "", // 凑单id
      minPoint: "", // 满多少
      amount: "", // 减多少
    };
  },
  computed: {
    ...mapGetters(["vuex_searchKey", "hasLogin"]),
  },
  watch: {
    $route: {
      handler(to, from) {
        this.pageFrom = to.query.pageFrom;
        this.secondOptions = [];
        this.pageNum = 1;
        this.total = 0;
        this.specialPic = "";
        this.isCookies = false;
        this.historySearchKey = "";
        if (this.pageFrom == "special") {
          this.subjectId = to.query.id;
          this.pageLoading = true;
          this.getSpeList();
        }
        if (this.pageFrom == "types") {
          this.value = to.query.categoryCode ? to.query.categoryCode : "";
          this.secondValue = to.query.categoryCode2
            ? to.query.categoryCode2
            : "";
          if (this.value != "") {
            if (this.secondValue != "") {
              this.change(this.value, this.secondValue);
            } else {
              this.getProductSort();
            }
          } else {
            this.pageLoading = true;
            this.getGoodsList();
          }
        }
        if (this.pageFrom == "quickOrder") {
          if (this.hasLogin) {
            this.value = "";
            this.secondValue = "";
            this.pageLoading = true;
            this.getRecentPurchase();
          } else {
            this.$router.push("/login?redirect=" + this.$route.fullPath);
          }
        }
        if (this.pageFrom == "groupOrder") {
          this.groupOrderId = to.query.groupOrderId;
          this.amount = to.query.amount;
          this.minPoint = to.query.minPoint;
          this.pageLoading = true;
          this.groupOrder();
        }
        if (this.pageFrom == "couponList") {
          const couponItem = sessionStorage.getItem("couponItem");
          if (couponItem) {
            this.couponItem = JSON.parse(couponItem);
          }
          this.couponId = to.query.couponId;
          this.pageLoading = true;
          this.couponList();
        }
      },
      immediate: false, //第一次就执行
    },
    "$store.state.userInfo.groupId"(val) {
      this.secondOptions = [];
      this.pageNum = 1;
      this.total = 0;
      this.specialPic = "";
      this.isCookies = false;
      this.historySearchKey = "";
      if (this.pageFrom == "special") {
        this.pageLoading = true;
        this.getSpeList();
      }
      if (this.pageFrom == "types") {
        if (this.value != "") {
          if (this.secondValue != "") {
            this.change(this.value, this.secondValue);
          } else {
            this.getProductSort();
          }
        } else {
          this.pageLoading = true;
          this.getGoodsList();
        }
      }
      if (this.pageFrom == "quickOrder") {
        if (this.hasLogin) {
          this.value = "";
          this.secondValue = "";
          this.pageLoading = true;
          this.getRecentPurchase();
        } else {
          this.$router.push("/login?redirect=" + this.$route.fullPath);
        }
      }
      if (this.pageFrom == "search") {
        this.specialPic = "";
        this.value = "";
        this.secondValue = "";
        this.pageLoading = true;
        this.pageNum = 1;
        this.secondOptions = [];
        this.isCookies = false;
        this.historySearchKey = this.vuex_searchKey;
        this.getProductSort();
      }
      if (this.pageFrom == "groupOrder") {
        this.pageLoading = true;
        this.groupOrder();
      }
      if (this.pageFrom == "couponList") {
        this.pageLoading = true;
        this.couponList();
      }
    },
    "$parent.searchClickNum": {
      handler(val) {
        if (this.historySearchKey != this.vuex_searchKey) {
          this.pageFrom = "search";
          this.specialPic = "";
          this.value = "";
          this.secondValue = "";
          this.pageLoading = true;
          this.pageNum = 1;
          this.secondOptions = [];
          this.isCookies = false;
          this.historySearchKey = this.vuex_searchKey;
          this.getProductSort();
        }
      },
      immediate: true, //第一次就执行
    },
  },
  beforeDestroy() {
    sessionStorage.removeItem("couponItem");
  },
  beforeMount() {
    this.routerPath = this.$route.path;
    if (Cookies.get("goodsListData")) {
      let goodsListData = JSON.parse(Cookies.get("goodsListData"));
      this.specialPic = "";
      this.value = goodsListData.value;
      this.secondValue = goodsListData.secondValue;
      this.pageNum = goodsListData.pageNum;
      this.pageFrom = goodsListData.pageFrom;
      this.subjectId = goodsListData.subjectId;
      this.couponId = goodsListData.couponId;
      this.groupOrderId = goodsListData.groupOrderId;
      this.amount = goodsListData.amount;
      this.minPoint = goodsListData.minPoint;
      this.couponItem = goodsListData.couponItem;
      this.historySearchKey = goodsListData.historySearchKey;
      if (JSON.stringify(this.couponItem) !== "{}") {
        sessionStorage.setItem("couponItem", JSON.stringify(this.couponItem));
      }
      Cookies.remove("goodsListData");
      this.isCookies = true;

      if (this.pageFrom == "types") {
        this.secondOptions = [];
        this.getProductSort();
      }
      if (this.pageFrom == "special") {
        this.pageLoading = true;
        this.getSpeList();
      }
      if (this.pageFrom == "quickOrder") {
        if (this.hasLogin) {
          this.pageLoading = true;
          this.getRecentPurchase();
        } else {
          this.$router.push("/login?redirect=" + this.$route.fullPath);
        }
      }
      if (this.pageFrom == "groupOrder") {
        this.pageLoading = true;
        this.groupOrder();
      }
      if (this.pageFrom == "couponList") {
        this.pageLoading = true;
        this.couponList();
      }
    } else {
      this.pageFrom = this.$route.query.pageFrom;
      this.isCookies = false;
      if (this.pageFrom == "types") {
        this.value = this.$route.query.categoryCode
          ? this.$route.query.categoryCode
          : "";
        this.secondValue = this.$route.query.categoryCode2
          ? this.$route.query.categoryCode2
          : "";
        this.getProductSort();
      }
      if (this.pageFrom == "special") {
        this.subjectId = this.$route.query.id;
        this.pageLoading = true;
        this.getSpeList();
      }
      if (this.pageFrom == "quickOrder") {
        if (this.hasLogin) {
          this.pageLoading = true;
          this.getRecentPurchase();
        } else {
          this.$router.push("/login?redirect=" + this.$route.fullPath);
        }
      }
      if (this.pageFrom == "groupOrder") {
        this.groupOrderId = this.$route.query.groupOrderId;
        this.amount = this.$route.query.amount;
        this.minPoint = this.$route.query.minPoint;
        this.pageLoading = true;
        this.groupOrder();
      }
      if (this.pageFrom == "couponList") {
        const couponItem = sessionStorage.getItem("couponItem");
        if (couponItem) {
          this.couponItem = JSON.parse(couponItem);
        }
        this.couponId = this.$route.query.couponId;
        this.pageLoading = true;
        this.couponList();
      }
    }
  },
  methods: {
    // 监听需要调用的逻辑
    watchInterface() {
      this.secondOptions = [];
      this.pageNum = 1;
      this.total = 0;
      this.specialPic = "";
      this.isCookies = false;
      this.historySearchKey = "";
      if (this.pageFrom == "special") {
        this.subjectId = to.query.id;
        this.pageLoading = true;
        this.getSpeList();
      }
      if (this.pageFrom == "types") {
        this.value = to.query.categoryCode ? to.query.categoryCode : "";
        this.secondValue = to.query.categoryCode2 ? to.query.categoryCode2 : "";
        if (this.value != "") {
          if (this.secondValue != "") {
            this.change(this.value, this.secondValue);
          } else {
            this.getProductSort();
          }
        } else {
          this.pageLoading = true;
          this.getGoodsList();
        }
      }
      if (this.pageFrom == "quickOrder") {
        if (this.hasLogin) {
          this.value = "";
          this.secondValue = "";
          this.pageLoading = true;
          this.getRecentPurchase();
        } else {
          this.$router.push("/login?redirect=" + this.$route.fullPath);
        }
      }
      if (this.pageFrom == "groupOrder") {
        this.groupOrderId = to.query.groupOrderId;
        this.amount = to.query.amount;
        this.minPoint = to.query.minPoint;
        this.pageLoading = true;
        this.groupOrder();
      }
      if (this.pageFrom == "couponList") {
        const couponItem = sessionStorage.getItem("couponItem");
        if (couponItem) {
          this.couponItem = JSON.parse(couponItem);
        }
        this.couponId = to.query.couponId;
        this.pageLoading = true;
        this.couponList();
      }
    },
    // 获取一级分类
    getProductSort() {
      getProductSort().then((res) => {
        if (res && res.code == 0 && res.data) {
          this.options = [
            {
              categoryId: "",
              name: "全部",
            },
          ];
          this.options.push(...res.data);
          if (this.value != "") {
            if (this.secondValue != "") {
              this.change(this.value, this.secondValue);
            } else {
              this.change(this.value);
            }
          } else {
            if (!this.isCookies) this.pageNum = 1;
            this.pageLoading = true;
            this.getGoodsList();
          }
        }
      });
    },
    // 获取二级分类
    change(e, secondValue) {
      if (e) {
        getProductSort({
          superiorId: e,
        }).then((res) => {
          if (res && res.code == 0 && res.data) {
            if (res.data.length > 0) {
              this.secondOptions = [
                {
                  categoryId: "",
                  name: "全部",
                },
              ];
              this.secondOptions.push(...res.data);
              this.secondValue = secondValue
                ? secondValue
                : this.secondOptions[0].categoryId;
            } else {
              this.secondOptions = [];
            }
            if (!this.isCookies) this.pageNum = 1;
            this.pageLoading = true;
            this.getGoodsList();
          }
        });
      } else {
        // 一级分类	全部
        if (!this.isCookies) this.pageNum = 1;
        this.value = "";
        this.secondValue = "";
        this.pageLoading = true;
        this.secondOptions = [];
        this.getGoodsList();
      }
    },
    // 获取商品
    getGoodsList() {
      search({
        q: this.vuex_searchKey,
        categoryCode: this.value,
        categoryCode2: this.secondValue,
        pageNum: this.pageNum,
        pageSize: 20,
      }).then((res) => {
        this.pageLoading = false;
        if (res && res.code == 0 && res.data) {
          this.goodsList = res.data.hits ? res.data.hits : [];
          this.total = res.data.totalHits;
          this.isCookies = false;
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
    // 切换页面
    handlePrev(type) {
      if (type == "next") this.pageNum++;
      if (type == "prev") this.pageNum--;
      if (this.pageFrom == "special") {
        this.pageLoading = true;
        this.getSpeList();
      }
      if (this.pageFrom == "types" || this.pageFrom == "search") {
        this.pageLoading = true;
        this.getGoodsList();
      }
      if (this.pageFrom == "quickOrder") {
        this.pageLoading = true;
        this.getRecentPurchase();
      }
      if (this.pageFrom == "groupOrder") {
        this.pageLoading = true;
        this.groupOrder();
      }
      if (this.pageFrom == "couponList") {
        this.pageLoading = true;
        this.couponList();
      }
    },
    // 获取专题详情
    getSpeList() {
      getPmsProductBaseBySubjectId({
        subjectId: this.subjectId,
        current: this.pageNum,
        size: 20,
      }).then((res) => {
        this.pageLoading = false;
        if (res && res.code == 0 && res.data && res.data.length > 0) {
          if (res.data[0].pic) {
            this.specialPic = res.data[0].banner;
          }
          this.goodsList = res.data[0].productDtos.records;
          this.total = res.data[0].productDtos.total;
        }
      });
    },
    // 近期采购商品
    getRecentPurchase() {
      recentPurchase({
        current: this.pageNum,
        size: 20,
      }).then((res) => {
        this.pageLoading = false;
        if (res && res.code == 0 && res.data) {
          this.goodsList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 凑单
    groupOrder() {
      groupOrderApi({
        activityId: this.groupOrderId,
        current: this.pageNum,
        size: 20,
      }).then((res) => {
        this.pageLoading = false;
        if (res && res.code == 0 && res.data) {
          this.goodsList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 优惠券列表
    couponList() {
      couponListApi({
        couponId: this.couponId,
        current: this.pageNum,
        size: 20,
      }).then((res) => {
        this.pageLoading = false;
        if (res && res.code == 0 && res.data) {
          this.goodsList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    changeSecond(e) {
      this.secondValue = e;
      this.pageNum = 1;
      this.pageLoading = true;
      this.getGoodsList();
    },
    handleCurrent(e) {
      this.pageNum = e;
      this.pageLoading = true;
      if (this.pageFrom == "special") {
        this.getSpeList();
      }
      if (this.pageFrom == "types" || this.pageFrom == "search") {
        this.getGoodsList();
      }
      if (this.pageFrom == "quickOrder") {
        this.getRecentPurchase();
      }
      if (this.pageFrom == "groupOrder") {
        this.groupOrder();
      }
      if (this.pageFrom == "couponList") {
        this.couponList();
      }
    },
    handleRouter(item) {
      let params = {
        value: this.value,
        secondValue: this.secondValue,
        pageNum: this.pageNum,
        pageFrom: this.pageFrom,
        subjectId: this.subjectId,
        historySearchKey: this.historySearchKey,
        couponId: this.couponId,
        groupOrderId: this.groupOrderId,
        amount: this.amount,
        minPoint: this.minPoint,
        couponItem: this.couponItem,
      };
      Cookies.set("goodsListData", params);
      this.$router.push("/goodsDetail?id=" + item.productTypeCode);
    },
  },
};
</script>

<style lang="scss">
.goods-list-container {
  .search-box-goodslist {
    border: none !important;
    border-radius: 10px !important;
    margin-bottom: 0 !important;
    padding: 0 !important;

    .classify-box {
      display: flex;
      align-items: center;

      .title {
        color: #262728;
        font-size: 14px;
        height: 32px;
        line-height: 32px;
        margin-right: 20px;
      }

      .icon {
        font-size: 20px;
        margin-top: -2px;
        margin-right: 20px;
        color: #909399;
      }

      .el-select {
        width: 200px;
        margin-right: 20px;

        .el-input__prefix {
          line-height: 32px;
          color: #909399;
          left: 10px;
        }

        .el-input__inner {
          border: 1px solid #c0c4cc;
          padding-left: 60px;
          color: #262728;
        }
      }

      .select-second {
        .el-input__inner {
          padding-left: 72px;
        }
      }
    }
  }

  .coupon-box {
    background: #fff;
    box-sizing: border-box;
    padding: 14px 14px;
    width: 100%;
    border-radius: 10px;
    position: relative;

    .coupon-info {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left-box {
        .name {
          font-size: 14px;
          color: #2a2a2a;
          margin-bottom: 11px;
          .time {
            width: 85px;
            text-align: right;
            display: inline-block;
            color: #999999;
          }
          .money {
            color: #f51010;
			font-size: 18px;
            .tips {
              margin-left: 5px;
			  font-size: 14px;
            }
          }
        }
        .name:last-child {
          margin-bottom: 0;
        }
      }

      .right-box {
      }
    }
  }

  .product-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .product-components {
      margin-right: 10px;
    }

    .product-components:nth-child(5n) {
      margin-right: 0;
    }
  }

  .pagination-box {
    width: 100%;
    text-align: center;

    .el-pagination {
      margin: 50px auto;

      .btn-prev,
      .btn-next,
      .el-pager li {
        background: none !important;
        height: 28px;
        line-height: 28px;
        font-weight: 400;
      }

      .el-pager li.active {
        background: #fece36 !important;
        color: #262728;
        border-radius: 8px;
        min-width: 28px;
        font-weight: bold;
      }
    }
  }
}
</style>
